export default __webpack_public_path__ + "static/media/thalia.c19c11b4.webp";